import { rowSize } from "@procore/data-table";

export const PERSON_ASSIGNMENTS_PAGE_SIZE = 10;

export interface AssignmentTableHeight {
   tableHeight: number;
   showPagination: boolean;
}

export const getAssignmentTableHeight = (
   rowCount: number,
   pageSize: number = rowCount,
): AssignmentTableHeight => {
   const rowHeight = rowSize.md; // default row size used by @procore/data-table (sm: 33, md: 49, lg: 65)
   const paginationHeight = 48; // AG Grid pagination bar height
   const maxHeight = 400; // maximum table height before it becomes scrollable
   const pageLimit = PERSON_ASSIGNMENTS_PAGE_SIZE;

   const showPagination = rowCount > pageLimit;
   const visibleRows = Math.min(rowCount, pageSize);
   const naturalHeight =
      rowHeight + visibleRows * rowHeight + (showPagination ? paginationHeight : 0) + 1; // Include AG Grid's 1px bottom border so the last row is fully visible without clipping.
   const tableHeight = Math.min(naturalHeight, maxHeight);
   return { tableHeight, showPagination };
};
